// src/home/Chatbot/chat.actions.js
import { chatService } from "./chat.service";
import { chatConstants } from "./chat.constants";

export const chatActions = {
  sendMessage,
  clearChat,
};

function sendMessage(text) {
  return (dispatch) => {
    dispatch({ type: chatConstants.SEND_MESSAGE_REQUEST, text });

    return chatService.sendQuery(text).then(
      (data) => {
        dispatch({ type: chatConstants.SEND_MESSAGE_SUCCESS, data });
      },
      (error) => {
        const errMsg = (error && error.message) || String(error);
        dispatch({
          type: chatConstants.SEND_MESSAGE_FAILURE,
          error: errMsg,
        });
      }
    );
  };
}

function clearChat() {
  chatService.clearConversation();
  return { type: chatConstants.CLEAR_CHAT };
}
